import { render, staticRenderFns } from "./TemplateMoveList.vue?vue&type=template&id=e24e2618&scoped=true&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./TemplateMoveList.vue?vue&type=script&lang=js"
export * from "./TemplateMoveList.vue?vue&type=script&lang=js"
import style0 from "./TemplateMoveList.vue?vue&type=style&index=0&id=e24e2618&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24e2618",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e24e2618')) {
      api.createRecord('e24e2618', component.options)
    } else {
      api.reload('e24e2618', component.options)
    }
    module.hot.accept("./TemplateMoveList.vue?vue&type=template&id=e24e2618&scoped=true&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml", function () {
      api.rerender('e24e2618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/appTemplate/component/TemplateMoveList.vue"
export default component.exports